/**
 * Ponto único de acesso ao Supabase (banco EXTERNO de produção).
 *
 * IMPORTANTE: NÃO trocar para o cliente auto-gerado em
 * @/integrations/supabase/client — aquele aponta para o banco interno
 * Lovable Cloud (wsuofwyhidnmbgnvoxdg), enquanto a autenticação,
 * profiles e dados de obras vivem no banco externo
 * (efvgrxgtjdsarvibjkap). Trocar quebra o login.
 *
 * SINGLETON: usamos cache em globalThis para garantir que o GoTrueClient
 * é criado UMA única vez mesmo com HMR/Vite ou múltiplos imports.
 */
import { createClient, type SupabaseClient } from '@supabase/supabase-js'

const SB_URL = 'https://efvgrxgtjdsarvibjkap.supabase.co'
const SB_KEY = 'sb_publishable_JK2Eas6deubpnbyDkvTC2Q_B6I6MRhj'
const STORAGE_KEY = 'cz-external-auth-token'

const globalForSupabase = globalThis as unknown as {
  __cz_external_supabase__?: SupabaseClient
}

export const supabase: SupabaseClient =
  globalForSupabase.__cz_external_supabase__ ??
  createClient(SB_URL, SB_KEY, {
    auth: {
      storage: localStorage,
      storageKey: STORAGE_KEY,
      persistSession: true,
      autoRefreshToken: true,
      // IMPORTANTE: desligado para não consumir automaticamente o hash
      // de recovery (#access_token=...&type=recovery). A página
      // /reset-password processa o token manualmente.
      detectSessionInUrl: false,
    },
  })

if (!globalForSupabase.__cz_external_supabase__) {
  globalForSupabase.__cz_external_supabase__ = supabase
}

/** Bucket padrão para fotos de obras (acesso via signed URL). */
export const BUCKET = 'fotos-obras'
